<div class="grid">
	<div class="col-12" [class]="this.underTablet() ? 'flex justify-content-center' : ''">
		<form [formGroup]="deviceFilters">
			<div class="grid mt-0">
				<div *ngIf="currentSite.CurrentlyOwned"
					[class]="underMinWidthCol4() ? 'col-12 pt-0 flex justify-content-center' : 'col-2 pt-0 flex justify-content-start'">
					<p-button id="buttonMaximumSharingSystem" label="{{ 'VCT_MAXIMUM_SHARING' | translate }}"
						icon="pi cm-share" (click)="enableMaximumSharingSystem()" [rounded]="false" [text]="true"
						severity="primary" styleClass="font-bold border-primary surface-900 hover:bg-blue-900">
					</p-button>
				</div>
				<div
					[class]="underMinWidthCol4() ? 'col-12 flex justify-content-center' : 'col-4 pt-0 flex justify-content-start'">
					<div
						[class]="(this.screenWidth <= COLUMN_TITLE_MIN_WD) ? 'grid' : 'flex align-items-center justify-content-around w-full'">
						<div
							[class]="(this.screenWidth <= COLUMN_TITLE_MIN_WD) ? 'col-6 flex align-items-center justify-content-center' : 'flex align-items-center'">
							<p-checkbox formControlName="assignFilter" name="activeFilter" [binary]="true"
								styleClass="mx-2"></p-checkbox>
							<p-tag icon="pi cm-user" value="{{ 'VCT_SHARE_ASSIGN' | translate }}" severity="success"></p-tag>
						</div>
						<div
							[class]="(this.screenWidth <= COLUMN_TITLE_MIN_WD) ? 'col-6 flex align-items-center justify-content-center' : 'flex align-items-center'">
							<p-checkbox formControlName="pendingFilter" name="readyFilter" [binary]="true"
								styleClass="mx-2"></p-checkbox>
							<p-tag icon="pi cm-mail" value="{{ 'INVITED_PENDING' | translate }}" severity="warning"></p-tag>
						</div>
						<div
							[class]="(this.screenWidth <= COLUMN_TITLE_MIN_WD) ? 'col-6 flex align-items-center justify-content-center' : 'flex align-items-center'">
							<p-checkbox formControlName="notAssignFilter" name="expiredFilter" [binary]="true"
								styleClass="mx-2"></p-checkbox>
							<p-tag icon="pi cm-cancel" value="{{ 'VCT_SHARE_NOT_ASSIGN' | translate }}" severity="danger"></p-tag>
						</div>
					</div>
				</div>
				<div
					[class]="underMinWidthCol4() ? 'col-12 pt-0 flex justify-content-center' : currentSite.CurrentlyOwned ? 'col-3 pt-0 flex justify-content-center' : 'col-4 flex justify-content-center'">
					<p-checkbox formControlName="onlyUnit" name="onlyUnit" [binary]="true" styleClass="mx-2"></p-checkbox>
					<div class="flex align-items-center gap-1">
						<div>{{ 'VIEW_ONLY' | translate }}</div>
						<p-tag icon="pi cm-derivate" value="{{ 'UNIT' | translate }}"
							styleClass="text-0 p-tag-lightBlue0240"></p-tag>
						<div>{{ 'AND' | translate }}</div>
						<p-tag icon="pi cm-plate" value="{{ 'VCT_OPENS' | translate }}"
							styleClass="text-0 p-tag-lightBlue0240"></p-tag>
					</div>
				</div>
				<div
					[class]="underMinWidthCol4() ? 'col-12 flex justify-content-center' : currentSite.CurrentlyOwned ? 'col-3 pt-0 flex align-items-center justify-content-end' : 'col-4 flex align-items-center justify-content-end'">
					<span class="p-input-icon-left" [class]="dynamicInputTextWidth()">
						<i class="pi cm-search"></i>
						<input formControlName="searchFilter" pInputText type="text" [ngClass]="dynamicInputTextWidth()"
							class="pr-6 surface-900" id="supportrequest-rbelog-input-search"
							placeholder="{{ 'SEARCH' | translate }}" maxlength="254" />
					</span>
				</div>
				<div class="col-12">
					<div class="flex align-items-center justify-content-center">
						<p-button label="{{ 'RELOAD' | translate }}"
							icon="pi cm-reload" size="large" (click)="$event.stopPropagation(); reloadVctList()"
							[rounded]="false" [text]="true" severity="secondary" styleClass="font-bold border-0">
						</p-button>
					</div>
				</div>
			</div>
		</form>
	</div>
</div>